import {EntityType} from '../../handlers/entity';
import {SourceInfo} from '../../utils/source-providers/sources-provider';

export function resolveMeterDashboardSources(
    meterDashboard: boolean,
    allSelectedSources: SourceInfo[] = [],
    selectedSources: SourceInfo[] = []
): SourceInfo[] {
    if (!meterDashboard) return selectedSources;
    const meterSources = (allSelectedSources || []).filter(source => source.type === EntityType.meter);
    return meterSources.length ? meterSources : selectedSources;
}
